import { createSlice } from '@reduxjs/toolkit'

const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    navbarSmall: false
  },
  reducers: {
    setNavbarSmall: (state, action) => {
      state.navbarSmall = action.payload;
    }
  }
})

export const { setNavbarSmall } = layoutSlice.actions;

export const layoutReducer = layoutSlice.reducer;
